export const ChatActionsEN = [
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😳</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😭</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😰</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😍</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">❓</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🤐</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'double',
    content: [
      {
        text: 'Obesity',
        isCorrect: true
      },
      {
        text: 'Undernutrition',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">😱</span>'
      }
    ]
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">💁</span>'
      }
    ]
  },
  {
    type: 'double',
    content: [
      {
        text: '1,000 tons',
        isCorrect: false
      },
      {
        text: '1 million tons',
        isCorrect: false
      },
      {
        text: '1.3 billion tons',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">🙀</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🤔</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😑</span>'
      }
    ]
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">🙋</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">✍️</span>'
      }
    ]
  },
  {
    type: 'openBadges',
    content: [
      {
        text: 'Cool, I get it!'
      }
    ],
    action: 'sdg'
  },
  {
    type: 'single',
    content: [
      {
        text: '😋'
      }
    ]
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: '<span class="emoji">💪</span> I was born ready!'
      }
    ],
    action: 'openCardsGame'
  },
  
  {
    type: 'single',
    content: [
      {
        text: 'Let’s go!'
      }
    ]
  },
  {
    type: 'double',
    content: [
      {
        text: 'Half in rural areas and half in urban areas ',
        isCorrect: true
      },
      {
        text: 'In rural areas ',
        isCorrect: false
      },
      {
        text: 'In urban areas ',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '5 out 10',
        isCorrect: false
      },
      {
        text: '7 out 10',
        isCorrect: true
      },
      {
        text: '9 out 10',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '25',
        isCorrect: false
      },
      {
        text: '40',
        isCorrect: true
      },
      {
        text: '33',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '150,000 ',
        isCorrect: false
      },
      {
        text: '1 million',
        isCorrect: false
      },
      {
        text: '2 million',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: 'An institution that mainly finances companies in the food sector',
        isCorrect: false
      },
      {
        text: 'A bank that follows the prices of food stocks ',
        isCorrect: false
      },
      {
        text: 'A charitable body that works in the reuse and redistribution of excess food ',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">✌</span>'
      }
    ]
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: 'Let’s go!'
      }
    ],
    action: 'openPyramid'
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: '<span class="emoji">💃</span> YESSSS! '
      }
    ],
    action: 'openVirtualDishes'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🙌</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🥰</span>'
      }
    ]
  },
  {
    type: 'openBadges',
    content: [
      {
        text: '<span class="emoji">🙌</span>'
      }
    ],
    action: 'chat'
  }
  
]